// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img.icon {\n  position: absolute;\n  left: -24px;\n  width: 16px;\n  height: 16px;\n  margin-top: 3px;\n}", ""]);
// Exports
module.exports = exports;
